// 🚀 Main Entry Point - Advanced React App with Modern Patterns
// React Patterns: StrictMode + Error Boundaries + Performance + Modern Setup

import React from 'react';
import ReactDOM from 'react-dom/client';
import 'antd/dist/reset.css';
import App from './App.jsx';
import { log } from './utils/log';

try {
  sessionStorage.removeItem('vite-lazy-reload');
  sessionStorage.removeItem('admin-blank-reload');
} catch {
  /* ignore */
}

const rootEl = document.getElementById('root');
const bootFail = document.getElementById('boot-fail');
if (bootFail) bootFail.classList.remove('visible');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (import.meta.env.DEV) {
  window.addEventListener('load', () => {
    setTimeout(() => {
      log.info('🚀 TejasFleets Car Rental Admin Dashboard Loaded');
      log.info('⚡ React Version:', React.version);
      log.info('🎯 Environment:', import.meta.env.MODE);
    }, 100);
  });
}
